import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const state = {}

const mutations = {
  changeParam(state, { key, value }) {
    if (!state.currentData) return
    state.currentData.params[key] = value
  }
}

const getters = {}

const actions = {
  saveImage({ state, commit }, { key, value }) {
    state.$collection.doc(key).set({ imageKey: value }, { merge: true }).then(doc => {
      commit('$change', { key: 'imageKey', value })
    })
  }
}

function migrationParams(params) {
  const res = {}
  Object.keys(params).forEach((key) => {
    if (typeof params[key] !== 'object') {
      res[key] = Number(params[key])
    } else {
      res[key] = Number(params[key].value)
    }
  })
  return res
}

function formatter({
  name = '',
  memo = '',
  note = '',
  imageKey = null,
  hidden = false,
  size = 1,
  params = {},
  timestamp = null
}) {
  return {
    name,
    memo,
    note,
    imageKey,
    hidden,
    size,
    params: migrationParams(params),
    timestamp
  }
}

export default new FirestoreCollectionStore({
  $name: 'characters',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})
